import ThreeCanvas from "../components/ThreeCanvas";
import ResponsiveHelper from "../utils/ResponsiveHelper";
import GsapScrollUtils from "../utils/GsapScrollUtils";

export default class PageLocation {
  constructor(dom) {
    this.dom = dom;
    window.addEventListener("resize", () => this.resize());
    this.gsu = null;
    this.init();
  }
  async init() {
    this.initResponsiveHelper();
    await this.initThreeCanvas();
    this.initGsap();
  }

  initResponsiveHelper() {
    this.rHelper = new ResponsiveHelper();
    window.addEventListener("onBreakpointChange", (e) => {
      //console.log(e.detail);
    });
  }

  initGsap() {
    this.gsu = new GsapScrollUtils();

    this.gsu.fadeOutOnLeave("[js-anim-fool]", {
      scrub: true,
      markers: false,
      playOnEnterBack: true,
    });

    this.gsu.fadeInOnEnter("[js-anim-fioe]", {
      scrub: true,
      markers: false,
      playOnEnterBack: true,
    });

    this.setupImgParallax();
    this.setupPin();
  }

  setupImgParallax() {
    const images = this.dom.querySelectorAll("[js-img-parallax]");
    if (!images || !images.length) return;

    const magnitude = 50;

    images.forEach((img, index) => {
      this.gsu.fromToWithScroll(
        img,
        {
          y: Math.pow(-1, index) * magnitude * (index + 1),
        },
        {
          y: -Math.pow(-1, index) * magnitude * (index + 1),
          ease: "none",
          scrollTrigger: {
            trigger: img.parentNode,
            start: "top bottom",
            end: "bottom top",
            scrub: true,
            markers: false,
          },
        },
      );
    });
  }

  setupPin() {
    if (!this.gsu) return;
    this.gsu.createPin({
      pin: "section.hero-wrapper",
      trigger: ".pin-wrapper",
      start: "top top",
      end: "bottom top",
      markers: false,
    });

    if (this.threeCanvas && this.threeCanvas.panoMesh) {
      const panoMesh = this.threeCanvas.panoMesh;

      panoMesh.rotation.x = Math.PI * -0.02;
      panoMesh.rotation.y = Math.PI * -0.6;

      // Use current rotation as the start and rotate Y by +90deg over the pin duration.
      const from = { x: panoMesh.rotation.x, y: panoMesh.rotation.y };
      const to = {
        x: panoMesh.rotation.x,
        y: panoMesh.rotation.y + Math.PI * 0.2,
        ease: "none",
        scrollTrigger: {
          trigger: ".pin-wrapper",
          start: "top top",
          end: "bottom top",
          scrub: true,
          markers: false,
        },
      };

      this.gsu.fromToWithScroll(panoMesh.rotation, from, to);
    }
  }

  setGsapReplay(allow) {
    if (this.gsu && typeof this.gsu.killAll === "function") {
      this.gsu.killAll();
    }
    this.initGsap();
  }

  async initThreeCanvas() {
    const canvasWrapperDOM = this.dom.querySelector("[js-canvas]");
    this.threeCanvas = new ThreeCanvas(canvasWrapperDOM);
    // wait for ThreeCanvas.init to finish (creates panoMesh)
    if (this.threeCanvas && typeof this.threeCanvas.init === "function") {
      await this.threeCanvas.init();
    }
  }

  resize() {
    if (this.gsu) {
      this.gsu.handleResize(() => {
        if (this.threeCanvas && typeof this.threeCanvas.resize === "function") {
          this.threeCanvas.resize();
        }

        // Recreate hero parallax so it uses the updated window height
        if (typeof this.setupHeroParallax === "function") {
          this.setupHeroParallax();
        }
      });
    } else if (
      this.threeCanvas &&
      typeof this.threeCanvas.resize === "function"
    ) {
      this.threeCanvas.resize();
    }
  }
}
